export const INIT_THEME_VALUE = {
  team: "8-1",
  name: "",
  backgroundColor: "beige",
  backgroundImageURL: null,
};

export enum BackgroundColor {
  Beige = "beige",
  Purple = "purple",
  Blue = "blue",
  Green = "green",
}
